import React, { useEffect, useState } from 'react';
import SummaryStrip, { totalFrom } from './summaryStrip';
import { valueTiles } from './rangedList';

// Clickable summary cards for the reports. The hero card is the record count (clicking it clears the filter); the other
// cards are the most common values of `fields` ([[key, n], ...]) plus any `extra` ({ label, id, test, color }) cards.
// Clicking a card filters the grid to its records (again to clear). The cards count every record of the search when the
// report has loaded them all (`exportData`), otherwise the rows on the current page.
// Returns { strip, shownRows, active }: render `strip`, give the grid `shownRows`, and hide the pager while `active`.
export const useReportCards = ({ label = 'Records in view', rowData, exportData, pagination, fields = [], extra = [] }) => {
  const [filter, setFilter] = useState(null);
  useEffect(() => { setFilter(null); }, [rowData]);

  const page = Array.isArray(rowData) ? rowData : [];
  const all = Array.isArray(exportData) && exportData.length ? exportData : page;
  const rows = page.length ? all : [];
  const complete = rows !== page;
  const note = complete ? 'records' : 'on this page';
  const toggle = (f) => setFilter((prev) => (prev?.id === f.id ? null : f));
  const cf = { statsRows: rows, filter, toggle };

  const tiles = [
    ...fields.flatMap(([key, n]) => valueTiles(cf, key, n, { note })),
    ...extra.map((e) => ({
      label: e.label, color: e.color, value: rows.filter(e.test).length, note, active: filter?.id === e.id, onClick: () => toggle({ id: e.id, test: e.test }),
    })),
  ];

  const strip = (
    <SummaryStrip
      label={label}
      total={totalFrom(pagination, page.length)}
      heroNote={filter ? 'Filtered' : 'All records'}
      heroActive={!filter}
      onHero={() => setFilter(null)}
      tiles={tiles}
      ariaLabel={label}
    />
  );

  return { strip, shownRows: filter ? rows.filter(filter.test) : rowData, active: !!filter };
};

export default useReportCards;
